import React from 'react';

import styles from './nearest-matches.module.css';

const NearestMatches = () => (
  <div className={styles.matchWrapper}>
    <p className={styles.emptyMatch}>Даты и время матчей еще не определены</p>
  </div>
);

export default NearestMatches;
